import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LaunchComponent } from './launch.component';
import { AdjustmentsHomeComponent } from './quick-search/adjustments/adjustments-home/adjustments-home.component';
import { UnderDevelopmentNoticeComponent } from './shared/display/under-development-notice/under-development-notice.component';
import { HomeComponent } from './feature/home/home.component';
import { SearchSnacksHomeComponent } from './feature/search-snacks-home/search-snacks-home.component';
import { RateHomeComponent } from './sandbox/rates/rate-home/rate-home.component';
import { RateHome2Component } from './sandbox/rates/rate-home2/rate-home2.component';
import { NewRateHomeComponent } from './sandbox/rates/new-rate-home/new-rate-home.component';
import { TestGridComponent } from './sandbox/grid-test/test-grid/test-grid/test-grid.component';
import { ParkerV2HomeComponent } from './profiles/parker-v2/parker-v2-home/parker-v2-home.component';
import ParkersV2ImportComponent from './profiles/parker-v2/parkers-v2-import/parkers-v2-import.component';
import { ParkerV2SpaceLinksComponent } from './profiles/parker-v2/parker-v2-space-links/parker-v2-space-links.component';
import { GridSpaceTestComponent } from './sandbox/igx-grid-standalone/grid-space-test/grid-space-test.component';
import { ParkersV2AgreementPreviewComponent } from './profiles/parker-v2/parkers-v2-agreement-preview/parkers-v2-agreement-preview/parkers-v2-agreement-preview.component';
import { RptParkingAgreementComponent } from './reports/parker/rpt-parking-agreement/rpt-parking-agreement.component';
import { ReportAgingComponent } from './reports/invoice/report-aging/report-aging.component';
import { TenantReportComponent } from './reports/general/tenant-report/tenant-report.component';
import { ReportPaymentComponent } from './reports/invoice/report-payment/report-payment.component';
import { GenerateGbComponent } from './utilities/invoices/generate-invoices/generate-gb/generate-gb.component';
import { GenerateMiComponent } from './utilities/invoices/generate-invoices/generate-mi/generate-mi.component';
import { UsersByLotComponent } from './admin/lot/users-by-lot/users-by-lot.component';
import { ReportRecurringTaskComponent } from './reports/admin/report-recurring-task/report-recurring-task.component';
import { AdminPatchMalformedSpaceAccountsComponent } from './admin/space/admin-patch-malformed-space-accounts/admin-patch-malformed-space-accounts.component';
import { AuthGuardService } from './core/services/guards/auth-guard.service';
import { MiDueDateReadonlyStatusComponent } from './admin/invoice/mi-due-date-readonly-status/mi-due-date-readonly-status.component';
import { ViewInvoiceComponent } from './invoice/view-invoice/view-invoice.component';
import { ParcsHomeComponent } from './admin/parcs/parcs-home/parcs-home.component';
import { ParcsManagementHomeComponent } from './profiles/parker-v2/parkers-v2-grid-components/parcs-management/parcs-management-home/parcs-management-home.component';
import { AmanoOneSyncComponent } from './admin/parcs/amano-one/amano-one-sync/amano-one-sync.component';
import { CardProcessingFeeComponent } from './utilities/lot-setup/card-processing-fee/card-processing-fee.component';
import { MiCreationSandboxComponent } from './sandbox/invoice/mi-creation-sandbox/mi-creation-sandbox.component';
import { GbInvoiceAdjustmentsComponent } from './quick-search/adjustments/adjust-billing/gb-invoice-adjustments/gb-invoice-adjustments.component';
import { GbInvoiceLineDescriptionOverrideComponent } from './admin/lot-setup/gb-invoice-line-description-override/gb-invoice-line-description-override.component';
import { SendInvoicesComponent } from './sandbox/invoice/send-invoices/send-invoices.component';
import { TaxAppliedCheckboxSandboxComponent } from './sandbox/invoice/tax-applied-checkbox-sandbox/tax-applied-checkbox-sandbox.component';
import { FinalizeMiComponent } from './invoice/finalize-mi/finalize-mi.component';
import { SendInvoicesHomeComponent } from './invoice/send-invoices/send-invoices-home/send-invoices-home.component';
import { SendInvoicesHomeV2Component } from './invoice/send-invoices/send-invoices-home-v2/send-invoices-home-v2.component';
import { CurrentInvoicesReportComponent } from './admin/invoice/current-invoices-report/current-invoices-report.component';
import { GbInvoiceJobManagementComponent } from './admin/invoice/gb-invoice-job-management/gb-invoice-job-management.component';
import { GbGenerationComponent } from './invoice/general-billing/gb-generation/gb-generation.component';
import { ReportWebjobsStatusComponent } from './reports/admin/report-webjobs-status/report-webjobs-status.component';
import { TasksJobsSettingsComponent } from './admin/settings/tasks-jobs-settings/tasks-jobs-settings.component';
import { FlashSyncHomeComponent } from './admin/parcs/flash/flash-sync-home/flash-sync-home.component';
import { ParcsFlashUtilitiesComponent } from './utilities/parcs/parcs-flash-utilities/parcs-flash-utilities.component';


const routes: Routes = [
  { path: 'apnlaunch/:key/:app', component: LaunchComponent },
  { path: 'ApnLaunch/:key/:app', component: LaunchComponent },
  { path: 'home', component: HomeComponent },
  { path: 'searchsnacks', component: SearchSnacksHomeComponent },
  {
    path: 'quicksearch',
    loadChildren: () => import('./quick-search/quick-search.module').then((m) => m.QuickSearchModule),
  },
  {
    path: 'invoice/generateprelimgb',
    component: GenerateGbComponent,
  },
  {
    path: 'invoice/generateprelimmi',
    component: GenerateMiComponent,
  },
  {
    path: 'companyimport',
    loadChildren: () =>
      import('./profiles/companies/company-import/company-import.module').then((m) => m.CompanyImportModule),
  },
  { path: 'company/:id', loadChildren: () => import('./profiles/company/company.module').then((m) => m.CompanyModule) },
  {
    path: 'company/:lotnumber/new',
    loadChildren: () => import('./profiles/company/company.module').then((m) => m.CompanyModule),
  },
  {
    path: 'company/:lotnumber/edit',
    loadChildren: () => import('./profiles/company/company.module').then((m) => m.CompanyModule),
  },
  {
    path: 'company/:lotnumber/detail',
    loadChildren: () => import('./profiles/company/company.module').then((m) => m.CompanyModule),
  },
  { path: 'parkerv2', component: ParkerV2HomeComponent },
  { path: 'parkerv2import', component: ParkersV2ImportComponent },
  { path: 'parkerv2spacelinks', component: ParkerV2SpaceLinksComponent },
  { path: 'parkingagreementpreview/:lotNumber', component: ParkersV2AgreementPreviewComponent },
  {
    path: 'quicksearchhome',
    loadChildren: () => import('./quick-search/quick-search.module').then((m) => m.QuickSearchModule),
  },
  { path: 'adminhome/:username', loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule) },
  { path: 'adminhome/:username/space', loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule) },
  {
    path: 'adminhome/:username/payments',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'adminhome/:username/profilesearch',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'adminhome/:username/spaceprofilesettings',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'adminhome/:username/invoicesearch',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'adminhome/:username/parkeragreementtemplate',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'adminhome/:username/reportparkingagreement',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'adminhome/:username/lotsetup',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'adminhome/:username/configenvironment',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'adminhome/:username/assignaccess',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
  },
  { path: 'adminhome/:username/space', loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule) },
  {
    path: 'companylist',
    loadChildren: () => import('./profiles/companies/companies.module').then((m) => m.CompaniesModule),
    //canActivate: [AuthGuardService],
  },
  { path: 'utilities', loadChildren: () => import('./utilities/utilities.module').then((m) => m.UtilitiesModule) },
  {
    path: 'utilities/lotsetup',
    loadChildren: () => import('./utilities/utilities.module').then((m) => m.UtilitiesModule),
  },
  { path: 'utilities/parcssyncsetup', component: AmanoOneSyncComponent },
  { path: 'utilities/flashparkingsyncsetup', component: FlashSyncHomeComponent },
  { path: 'utilities/flashparkingutilities', component: ParcsFlashUtilitiesComponent },
  
  { path: 'sandbox', loadChildren: () => import('./sandbox/sandbox.module').then((m) => m.SandboxModule) },
  { path: 'sandbox/quicksearch', loadChildren: () => import('./sandbox/sandbox.module').then((m) => m.SandboxModule) },
  { path: 'adjustmentsHome/:invoicenumber', component: AdjustmentsHomeComponent },
  { path: 'reportrecurringtasks', component: ReportRecurringTaskComponent },
  { path: 'reportpayments', component: ReportPaymentComponent },
  { path: 'reportparkingagreement', component: RptParkingAgreementComponent },
  { path: 'reportaging', component: ReportAgingComponent },
  { path: 'reporttenant', component: TenantReportComponent },
  { path: 'report/webjobstatus', component: ReportWebjobsStatusComponent },
  { path: 'underdevelopment', component: UnderDevelopmentNoticeComponent },
  { path: 'sandbox/ratehome1', component: RateHomeComponent },
  { path: 'sandbox/ratehome2', component: RateHome2Component },
  { path: 'sandbox/newratehome', component: NewRateHomeComponent },
  { path: 'sendinvoices', component: SendInvoicesHomeComponent },
  { path: 'sendinvoices-v2', component: SendInvoicesHomeV2Component },
  { path: 'usersforlotnumber', component: UsersByLotComponent },
  { path: 'testgrid', component: TestGridComponent },
  { path: 'grid-space-test', component: GridSpaceTestComponent },
  { path: 'adminfixspaceaccounts', component: AdminPatchMalformedSpaceAccountsComponent },
  { path: 'adminminreadonlylot', component: MiDueDateReadonlyStatusComponent },
  { path: 'adminparcshome', component: ParcsHomeComponent },
  { path: 'admin/invoicelinecustomization', component: GbInvoiceLineDescriptionOverrideComponent },
  { path: 'admin/currentInvoices', component: CurrentInvoicesReportComponent },
  { path: 'admin/gbInvoiceJobs', component: GbInvoiceJobManagementComponent },
  {
    path: 'grid-space-module-test',
    loadChildren: () => import('./sandbox/igx-grid-module/igxgrid.module').then((m) => m.IgxGridTestModule),
  },

  { path: 'badroute', loadChildren: () => import('./core/bad-route/bad-route.module').then((m) => m.BadRouteModule) },
  { path: 'viewinvoice/:entityId/:lotNumber/:invoicenumber', component: ViewInvoiceComponent },
  { path: 'finalizeinvoice/:lotNumber/:entityId/:invoicenumber', component: FinalizeMiComponent },
  // { path: 'sandbox/gbcreationsandbox', component: GbCreationSandboxComponent },
  { path: 'sandbox/micreationsandbox', component: MiCreationSandboxComponent },
  { path: 'sandbox/sendinvoice', component: SendInvoicesComponent },
  { path: 'sandbox/taxappliedcheckbox', component: TaxAppliedCheckboxSandboxComponent },
  { path: '', loadChildren: () => import('./quick-search/quick-search.module').then((m) => m.QuickSearchModule) },
  { path: 'sandbox/gbcreation', component: GbGenerationComponent },
  { path: 'admin/tasks/settings', component: TasksJobsSettingsComponent }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
